import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';

import { ApiRequestDescriptor } from '../../services';

export interface DeleteFileRequestArgs {
  endpoint: string;
  blobValue?: string;
}

export const deleteFileRequest = ({
  endpoint,
  blobValue,
}: DeleteFileRequestArgs): ApiRequestDescriptor => ({
  url: endpoint,
  config: {
    method: SUPPORTED_METHODS.DELETE,
    json: {
      blobName: blobValue,
    },
  },
});
